import React from 'react';

export default ({ className }) => (
  <svg className={className} xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16">
    <path fillRule="evenodd"
          d="M6,2.50034732 C6,2.22401312 6.23193359,2 6.5,2 C6.77614237,2 7,2.22900057 7,2.50034732 L7,13.4996527 C7,13.7759869 6.76806641,14 6.5,14 C6.22385763,14 6,13.7709994 6,13.4996527 L6,2.50034732 Z M9,2.50034732 C9,2.22401312 9.23193359,2 9.5,2 C9.77614237,2 10,2.22900057 10,2.50034732 L10,13.4996527 C10,13.7759869 9.76806641,14 9.5,14 C9.22385763,14 9,13.7709994 9,13.4996527 L9,2.50034732 Z"/>
  </svg>
);
